import { type FC } from "react";
import { Icon } from "@root/shared/components/Icon";
import * as styles from "./styles.css";

type Props = {
  iconName:
    "cross-bold" | "arrow-bold-up" | "arrow-bold-left" | "arrow-bold-right" | "arrow-bold-down";
  isBackgroundTransparent?: boolean;
} & JSX.IntrinsicElements["button"];

export const RoundButton: FC<Props> = ({ iconName, isBackgroundTransparent = false, ...rest }) => {
  return (
    <button type="button" className={styles.button({ isBackgroundTransparent })} {...rest}>
      <Icon name={iconName} fontSize="16px" />
    </button>
  );
};
